import React, { useState } from 'react';

// Helper Functions
const formatDate = (dateString, withTime = false) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const options = { day: "numeric", month: "short", year: "numeric" };
  let formatted = date.toLocaleDateString("en-GB", options);
  if (withTime) {
    const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: true };
    const timeStr = date.toLocaleTimeString("en-GB", timeOptions);
    formatted += ", " + timeStr;
  }
  return formatted;
};

const formatDateLrProcess = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = d.toLocaleString("en-US", { month: "short" });
  const year = String(d.getFullYear()).slice(-2);
  return `${day} ${month} ${year}`;
};

const formatCurrency = (num) => {
  return num == null || isNaN(num) ? '₹ 0' : '₹ ' + Number(num).toLocaleString('en-IN');
};

const PartyLRPaymentDetails = ({
  trip_detail = {},
  logo = "https://via.placeholder.com/28",
  redirect_url = "#"
}) => {
  const [expandedLRs, setExpandedLRs] = useState([]);
  const [activeAccordions, setActiveAccordions] = useState({});
  const [sliderPosition, setSliderPosition] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);

  const toggleLR = (lrId) => {
    setExpandedLRs(prev =>
      prev.includes(lrId) ? prev.filter(id => id !== lrId) : [...prev, lrId]
    );
  };

  const toggleAccordion = (lrId, accordionId) => {
    const key = `${lrId}_${accordionId}`;
    setActiveAccordions(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const handleStart = (e) => {
    if (isCompleted) return;
    setIsDragging(true);
  };

  const handleMove = (e) => {
    if (!isDragging || isCompleted) return;
    
    const container = e.currentTarget;
    const containerWidth = container.offsetWidth;
    const sliderWidth = 60;
    const maxSlide = containerWidth - sliderWidth;
    
    let clientX;
    if (e.type.includes('touch')) {
      clientX = e.touches[0].clientX;
    } else {
      clientX = e.clientX;
    }
    
    const rect = container.getBoundingClientRect();
    let newPosition = clientX - rect.left - (sliderWidth / 2);
    
    if (newPosition < 0) newPosition = 0;
    if (newPosition > maxSlide) newPosition = maxSlide;
    
    setSliderPosition(newPosition);
    
    if (newPosition >= maxSlide * 0.95) {
      setIsCompleted(true);
      setIsDragging(false);
      window.location.href = "https://play.google.com/store/apps/details?id=com.transport360app&hl=en_IN";
    }
  };

  const handleEnd = () => {
    setIsDragging(false);
    if (!isCompleted) {
      setSliderPosition(0);
    }
  };

  const statusMap = {
    1: "Draft",
    2: "In Transit",
    3: "At Party",
    4: "Delivered",
    5: "Cancelled"
  };
  const currentStatus = statusMap[trip_detail?.trip_status] || "Unknown";

  const fromLoc = Array.isArray(trip_detail?.from_location) && trip_detail.from_location.length > 0
    ? trip_detail.from_location[0] : null;
  const toLoc = Array.isArray(trip_detail?.to_location) && trip_detail.to_location.length > 0
    ? trip_detail.to_location[trip_detail.to_location.length - 1] : null;

  const fromCity = fromLoc?.from_city || "";
  const fromState = fromLoc?.from_state || "";
  const fromCities = (fromCity || fromState)
    ? [fromCity, fromState].filter(Boolean).join(" | ")
    : "Origin Not Specified";

  const toCity = toLoc?.to_city || "";
  const toState = toLoc?.to_state || "";
  const toCities = (toCity || toState)
    ? [toCity, toState].filter(Boolean).join(" | ")
    : "Destination Not Specified";

  const lrList = Array.isArray(trip_detail?.lr_list) ? trip_detail.lr_list : [];

  const defaultSteps = [
    { type: 'pending', name: 'Pending' },
    { type: 'intransit', name: 'Intransit' },
    { type: 'party_point', name: 'Party Point' },
    { type: 'delivered', name: 'Delivered' },
    { type: 'bill_raised', name: 'Bill Raised' }
  ];

  const calculateTotal = (transactions) => {
    if (!Array.isArray(transactions)) return 0;
    return transactions.reduce((sum, txn) => sum + (txn.total_amount || 0), 0);
  };

  const getPaymentModeName = (item) => {
    if (item?.vendor_type === 5) return item?.vendor_detail?.name || '-';
    const mode = item?.payment_mode?.name || '';
    let acc = '';
    if (item?.payment_mode?.account_sub_category === 2) {
      const bank = item?.payment_mode?.account?.name || '';
      const num = item?.vendor_bank_account?.account_number || '';
      acc = bank && num ? `${bank} ${num.replace(/.(?=.{4})/g, 'X')}` : (bank || num || '-');
    } else {
      acc = item?.payment_mode?.account?.name || '-';
    }
    return mode ? `${mode} ${acc}` : acc;
  };

  return (
    <>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { background-color: #f1f1f3; font-family: "Roboto", sans-serif; }
        .__mainMob {
          background-color: #F5F8FD; max-width: 480px; width: 100%; height: 100vh;
          margin: 0 auto; display: flex; overflow: auto; flex-direction: column;
          scrollbar-width: none; -ms-overflow-style: none;
        }
        .__mainMob::-webkit-scrollbar { display: none; }
        .__headMob {
          display: flex; background-color: #ffffff; min-height: 63px;
          align-items: center; padding: 0 12px; gap: 9px; border: 1px solid #E8E7E7;
        }
        .__headMob h1 {
          font-family: "Inter", sans-serif; font-size: 19.45px;
          color: #000D25; font-weight: 500; margin: 0;
        }
        .__headMob h1 span { color: #0066FF; }
        .__hedIcon {
          width: 37px; height: 37px; border: 1px solid #dededee6;
          border-radius: 7px; display: flex; justify-content: center; align-items: center;
        }
        .__hedIcon img { width: 28px; }
        .__bodyMob { flex: 1; display: flex; flex-direction: column; gap: 6px; }
        .__whtHed {
          background-color: #ffffff; padding: 19px 16px 16px; border: 1px solid #E8E7E7;
        }
        .__whtHed h4 {
          font-size: 16px; color: #101828; line-height: 24px; margin-bottom: 4px;
        }
        .__whtHed p { font-size: 12px; color: #4A5565; margin-bottom: 4px; }
        .__whtHed p:last-child { margin-bottom: 0px; }
        .__plpHd_txt {
          background-color: #F0F1FB; border: 1px solid #E8E7E7; padding: 8px 12px;
        }
        .__plpHd_txt h3, .__plpDetails h3 {
          font-size: 16px; line-height: 24px; font-weight: 400; margin-bottom: 0px;
        }
        .__plpHd_txt h3 { color: #000000; }
        .__plpDetails {
          background-color: #ffffff; border-bottom: 1px solid #E8E7E7;
          padding: 12px 12px 14px; display: flex; justify-content: space-between; align-items: center;
        }
        .__plpDetails h3 { color: #101828; }
        .__plpDetails p { font-size: 12px; color: #6A7282; margin: 0px; }
        .__inTr_tag {
          min-height: 27px; min-width: 71px; font-size: 12px;
          background-color: #DCFCE7; color: #008236; display: flex;
          align-items: center; justify-content: center; border-radius: 50px;
        }
        .__vhlDetailBx {
          background-color: #ffffff; border: 1px solid #E8E7E7; padding: 16px 18px 20px;
        }
        .__vhlDetailBx h3 {
          font-size: 16px; color: #003C97; margin-bottom: 0px; line-height: 27px;
        }
        .__vhlDetailBx p { font-size: 12px; color: #6A7282; margin: 0px; }
        .route {
          font-size: 15px; display: flex; flex-direction: column;
          gap: 20px; overflow: hidden; position: relative; margin-top: 20px;
        }
        .route-row { display: flex; align-items: baseline; gap: 12px; margin-bottom: 0px; }
        span.source-icon:after {
          content: ""; position: absolute; width: 0px; height: calc(100% - 4px);
          border-right: 1px dashed #c4c4c4; z-index: 0; top: 3px;
        }
        .source-icon, .destination-icon {
          display: inline-flex; width: 20px; justify-content: center; align-items: center;
        }
        .source-icon i { color: #4caf50; z-index: 1; background: #fff; }
        .destination-icon i { color: #f44336; }
        span.destination-icon, .source-icon i { position: relative; }
        .route-text { flex: 1; line-height: 19px; }
        .route-row .city { font-weight: 600; color: #333; font-size: 16px; }
        .__lrDetail_mx {
          display: flex; flex-direction: column; gap: 6px; padding: 6px 6px 0px;
        }
        .__lrSep_bxs {
          background-color: #ffffff; border: 1px solid #e8e7e7;
          padding: 12px 12px 8px; border-radius: 4px;
        }
        .__lrInfo { display: flex; justify-content: space-between; align-items: center; }
        .__lrInfo h4 { font-size: 14px; color: #101828; margin: 0px; }
        .__lrInfo h4.__lrUseNamme { color: #1450EC; }
        .__lrCd { opacity: 0.7; }
        ._lrlRout_ls {
          display: flex; flex-wrap: wrap; justify-content: space-between;
          margin-top: 5px; margin-bottom: 8px;
        }
        ._lrHead_fsx { flex: 0 0 calc(50% - 72px); }
        ._lrHead_fsx h3 {
          color: #000000; font-size: 16px; font-weight: 500; line-height: 27px;
          margin-bottom: 0; letter-spacing: 0.32px; display: -webkit-box;
          -webkit-line-clamp: 1; -webkit-box-orient: vertical;
          overflow: hidden; text-overflow: ellipsis; padding: 0px;
        }
        ._lrs_rSide h3 { text-align: right; }
        ._lrHead_fsx p {
          color: #000000; font-size: 12px; font-weight: 400;
          line-height: normal; letter-spacing: 0.24px; margin: 0;
        }
        .__collApse_nw { text-align: center; }
        .__cleBtn {
          color: #1450EC; font-size: 14px; background-color: transparent;
          border: none; cursor: pointer;
        }
        .__cleBtn span.__viwLess { display: none; }
        .__cleBtn span.__viwDetail { display: block; }
        .__cleBtn.expanded .__viwLess { display: block; }
        .__cleBtn.expanded .__viwDetail { display: none; }
        .__lrsCommon { display: flex; }
        .__stepsBx { flex-direction: column; gap: 9px; flex: 1; }
        .__stepIcon { text-align: center; width: 100%; }
        .__stepIcon, .__stepsBx { align-items: center; display: flex; }
        .__stepInfos {
          display: flex; flex-direction: column; gap: 4px;
          text-align: center; padding: 0px 3px; width: 100%;
        }
        .__stepInfos p {
          color: #323232; font-size: 12px; font-weight: 400;
          letter-spacing: .24px; line-height: normal; margin-bottom: 0; opacity: .9;
        }
        .__stepsBx_active .__stepInfos p { font-weight: 500; }
        .__stepIcon:after, .__stepIcon:before {
          background-color: #d9d9d9; content: ""; display: block; height: 1px; position: relative;
        }
        .__stepIcon:after, .__stepIcon:before {
          flex: calc(50% - 11px); width: calc(50% - 11px);
        }
        .__stepsBx:first-child .__stepIcon:before,
        .__stepsBx:last-child .__stepIcon:after { opacity: 0; }
        .__stepIcon svg circle { fill: #D9D9D9; }
        .__stepIcon svg path { stroke: #D9D9D9; }
        .__stepsBx_active .__stepIcon svg circle { fill: #1450EC; }
        .__stepsBx_active .__stepIcon svg path { stroke: #ffffff; }
        .__lrsCollapse { padding: 20px 0px 25px; display: none; }
        .__lrsCollapse.show { display: block; }
        .__lPay_details { margin: 28px 0px 21px; }
        .__lPay_details h2 {
          font-size: 16px; color: #000000; font-weight: 500; margin: 0px;
        }
        .__lPay_details h2 span { margin-left: 8px; opacity: 0.7; }
        .__pdAccordian { display: flex; flex-direction: column; gap: 13px; }
        .__smAccr { display: flex; justify-content: space-between; }
        .__smAccr h2 {
          font-size: 16px; color: #000000; font-weight: 400; margin: 0px;
        }
        .__smAccr.total_bar h2 { color: #4373F0; }
        .__pdAccordian .accordion {
          display: flex; flex-direction: column; gap: 12px;
        }
        .__pdAccordian .accordion-item { border: none; }
        .__pdAccordian .accordion-button:focus { box-shadow: none; }
        .__pdAccordian .accordion-button {
          padding: 0px; background: transparent; border: none;
          width: 100%; display: flex; align-items: center;
          cursor: pointer; box-shadow: none;
        }
        .__pdAccordian .accordion-button .__firstSpan { order: 1; }
        
        .__pdAccordian .accordion-button:not(.no-arrow)::after {
          order: 2; margin-left: 7px; content: "";
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
          width: 15px; height: 15px; background-size: 15px;
          background-repeat: no-repeat; transition: transform 0.2s;
        }
        .__pdAccordian .accordion-button:not(.no-arrow).collapsed::after {
          transform: rotate(-90deg);
        }
        
        .__pdAccordian .accordion-button.no-arrow::after {
          display: none !important; content: none !important;
          width: 0 !important; height: 0 !important;
          margin: 0 !important; background: none !important;
        }
        .__pdAccordian .accordion-button.no-arrow {
          cursor: default !important; pointer-events: none !important;
        }
        
        .__pdAccordian .accordion-button .__thirdSpan {
          order: 3; margin-left: auto;
        }
        .__pdAccordian .accordion-button .__firstSpan,
        .__pdAccordian .accordion-button .__thirdSpan {
          font-size: 15px; color: #000000; font-weight: 400;
        }
        .__pdAccordian .accordion-body {
          border: 1px solid #DBE5FF; border-radius: 8px;
          margin-top: 6px; padding: 0px 11px; display: none;
        }
        .__pdAccordian .accordion-body.show { display: block; }
        .__innerTb_xs { padding: 10px 0px 10px; border-bottom: 1px solid #DBE5FF; }
        .__innerTb_xs:last-child { border-bottom: 0px; }
        .__belowRtc p {
          font-size: 12px; color: #000000; margin: 0px; opacity: 0.5;
        }
        .__underAppro_tag {
          font-size: 8px; border: 1px solid #F7D838;
          background-color: #FFF9E2; color: #494634cc;
          min-height: 16px; min-width: 64px; display: inline-flex;
          justify-content: center; align-items: center;
          margin-left: 3px; border-radius: 3px;
        }
        .__innerTb_xs .__smAccr h2 { display: flex; align-items: center; }
        .__footmob { padding-top: 18px; }
        .__footFirst { padding-bottom: 127px; }
        .__footFirst p {
          font-size: 12px; color: #4A5565; margin: 0px; text-align: center;
        }
        .__footFirst p span { color: #000000; }
        .__footSecond {
          background-color: #ffffff; padding: 8px 18px 12px;
          position: fixed; width: 100%; bottom: 0px; left: 0;
        }
        .__footSecond p {
          color: #4A5565; margin-bottom: 8px; text-align: center; font-size: 14px;
        }
        
        .__slideButton {
          position: relative; background: linear-gradient(90deg, #1956F6 0%, #0d3db8 100%);
          border-radius: 8px; min-height: 52px; width: 100%;
          overflow: hidden; cursor: pointer; user-select: none;
          touch-action: none;
        }
        
        .__slideButton.__completed {
          background: linear-gradient(90deg, #00C853 0%, #00962f 100%);
        }
        
        .__slideTrack {
          position: absolute; top: 0; left: 0; right: 0; bottom: 0;
          display: flex; align-items: center; justify-content: center;
          pointer-events: none;
        }
        
        .__slideText {
          font-size: 16px; color: #ffffff; font-weight: 500;
          transition: opacity 0.3s; z-index: 1;
        }
        
        .__slideButton.__dragging .__slideText {
          opacity: 0.5;
        }
        
        .__slideButton.__completed .__slideText {
          opacity: 1;
        }
        
        .__slider {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 60px;
    height: 56px;
    background: rgb(255 255 255 / 18%);
    backdrop-filter: blur(-1px);
    border: 1px solid rgb(255 255 255 / 0%);
    border-radius: 6px;
    display: flex
;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: left 0.1s ease-out;
    z-index: 2;
}
        
        .__slider i {
          font-size: 20px; color: #ffffff;
          text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
          transition: transform 0.3s;
        }
        
        .__slideButton.__dragging .__slider {
          transition: none;
        }
        
        .__slideButton.__completed .__slider {
          left: calc(100% - 60px) !important;
          background: rgba(0, 200, 83, 0.4);
          border: 1px solid rgba(255, 255, 255, 0.5);
        }
        
        .__slideButton.__completed .__slider i {
          color: #ffffff; transform: scale(1.2);
        }
        
        .__stepsBx:first-child .__stepInfos { padding-left: 0px; }
        .__stepsBx:last-child .__stepInfos { padding-right: 0px; }
      `}</style>

      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Roboto:wght@400;500&display=swap"
        rel="stylesheet"
      />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
      />

      <section className="__mainMob">
        <div className="__headMob">
          <div className="__hedIcon">
            <img src={logo} alt="logo" />
          </div>
          <h1>Transport <span>360</span></h1>
        </div>

        <div className="__bodyMob">
          <div className="__whtHed">
            <h4>{trip_detail?.company_id?.company || 'Company Name'}</h4>
            <p>{[trip_detail?.company_id?.address_line1, trip_detail?.company_id?.city?.label].filter(Boolean).join(', ') || 'Address'}</p>
            <p>
              Contact: <a href={`tel:${trip_detail?.company_id?.contact_no}`}>{trip_detail?.company_id?.contact_no || 'N/A'}</a>
              &nbsp;&nbsp;&nbsp; PAN Number : {trip_detail?.company_id?.pan_no || 'N/A'}
            </p>
            <p>GSTIN: {trip_detail?.company_id?.gst_no || 'N/A'}</p>
          </div>

          <div className="__plp_head">
            <div className="__plpHd_txt">
              <h3>Party LR & Payment Details</h3>
            </div>
            <div className="__plpDetails">
              <div>
                <h3>Trip #{trip_detail?.trip_number || 'Not Available'}</h3>
                <p>{formatDate(trip_detail?.dispatch_date, true) || 'Date Not Set'}</p>
              </div>
              <div className="__inTr_tag">{currentStatus}</div>
            </div>
          </div>

          <div className="__vhlDetailBx">
            <h3>{trip_detail?.vehicle_id?.vehicle_no || 'No vehicle assigned'}</h3>
            <p>Vehicle Number</p>
            <div className="route">
              <div className="route-row">
                <span className="source-icon"><i className="fa-regular fa-circle"></i></span>
                <div className="route-text"><span className="city">{fromCities}</span></div>
              </div>
              <div className="route-row">
                <span className="destination-icon"><i className="fa-solid fa-location-dot"></i></span>
                <div className="route-text"><span className="city">{toCities}</span></div>
              </div>
            </div>
          </div>

          {lrList.length > 0 && lrList.map((lr, lrIndex) => {
            const lrId = lr._id || `lr_${lrIndex}`;
            const isExpanded = !expandedLRs.includes(lrId);
            const lrProcess = Array.isArray(lr.lr_process) ? lr.lr_process : [];

            return (
              <div key={lrId} className="__lrDetail_mx">
                <div className="__lrSep_bxs">
                  <div className="__lrInfo">
                    <h4 className="__lrUseNamme">{lr?.consignor_id?.name || 'Not Available'}</h4>
                    <h4 className="__lrCd"># {lr?.lr_number || 'N/A'}</h4>
                  </div>

                  <div className="_lrlRout_ls">
                    <div className="_lrHead_fsx">
                      <h3>{lr?.from_location || 'N/A'}</h3>
                      <p>{formatDate(lr?.dispatch_date)}</p>
                    </div>
                    <div className="px-1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="136" height="29" viewBox="0 0 136 29" fill="none">
                        <path d="M0 15L51 15" stroke="#DFE8FF"></path>
                        <path d="M85 15L136 15" stroke="#DFE8FF"></path>
                        <circle cx="67.5" cy="14.5" r="14.5" fill="#DFE8FF"></circle>
                        <path d="M63.5 6C62.837 6 62.2011 6.26339 61.7322 6.73223C61.2634 7.20107 61 7.83696 61 8.5V17.5C61 18.318 61.393 19.044 62 19.5V21.5C62 21.6326 62.0527 21.7598 62.1464 21.8536C62.2402 21.9473 62.3674 22 62.5 22H64.5C64.6326 22 64.7598 21.9473 64.8536 21.8536C64.9473 21.7598 65 21.6326 65 21.5V20H71V21.5C71 21.6326 71.0527 21.7598 71.1464 21.8536C71.2402 21.9473 71.3674 22 71.5 22H73.5C73.6326 22 73.7598 21.9473 73.8536 21.8536C73.9473 21.7598 74 21.6326 74 21.5V19.5C74.607 19.044 75 18.318 75 17.5V8.5C75 7.83696 74.7366 7.20107 74.2678 6.73223C73.7989 6.26339 73.163 6 72.5 6H63.5ZM63 9C63 8.73478 63.1054 8.48043 63.2929 8.29289C63.4804 8.10536 63.7348 8 64 8H72C72.2652 8 72.5196 8.10536 72.7071 8.29289C72.8946 8.48043 73 8.73478 73 9V12.9C73 13.525 72.438 13.992 71.83 13.894C70.925 13.747 69.208 13.5 68 13.5C66.792 13.5 65.075 13.747 64.17 13.894C64.0259 13.9175 63.8784 13.9093 63.7378 13.8702C63.5971 13.8311 63.4666 13.7618 63.3554 13.6673C63.2441 13.5728 63.1547 13.4552 63.0933 13.3227C63.032 13.1902 63.0001 13.046 63 12.9V9ZM64 18C63.7348 18 63.4804 17.8946 63.2929 17.7071C63.1054 17.5196 63 17.2652 63 17C63 16.7348 63.1054 16.4804 63.2929 16.2929C63.4804 16.1054 63.7348 16 64 16C64.2652 16 64.5196 16.1054 64.7071 16.2929C64.8946 16.4804 65 16.7348 65 17C65 17.2652 64.8946 17.5196 64.7071 17.7071C64.5196 17.8946 64.2652 18 64 18ZM72 18C71.7348 18 71.4804 17.8946 71.2929 17.7071C71.1054 17.5196 71 17.2652 71 17C71 16.7348 71.1054 16.4804 71.2929 16.2929C71.4804 16.1054 71.7348 16 72 16C72.2652 16 72.5196 16.1054 72.7071 16.2929C72.8946 16.4804 73 16.7348 73 17C73 17.2652 72.8946 17.5196 72.7071 17.7071C72.5196 17.8946 72.2652 18 72 18ZM67 16H69C69.2652 16 69.5196 16.1054 69.7071 16.2929C69.8946 16.4804 70 16.7348 70 17C70 17.2652 69.8946 17.5196 69.7071 17.7071C69.5196 17.8946 69.2652 18 69 18H67C66.7348 18 66.4804 17.8946 66.2929 17.7071C66.1054 17.5196 66 17.2652 66 17C66 16.7348 66.1054 16.4804 66.2929 16.2929C66.4804 16.1054 66.7348 16 67 16Z" fill="#1450EC"></path>
                      </svg>
                    </div>
                    <div className="_lrHead_fsx _lrs_rSide">
                      <h3>{lr?.to_location || 'N/A'}</h3>
                    </div>
                  </div>

                  <div className={`__lrsCollapse ${isExpanded ? 'show' : ''}`}>
                    <div className="__lrsCommon">
                      {defaultSteps.map((step, stepIndex) => {
                        const found = lrProcess.find(p => p.type === step.type);
                        const isActive = found && found.status === 1;
                        return (
                          <div key={stepIndex} className={`__stepsBx ${isActive ? '__stepsBx_active' : ''}`}>
                            <div className="__stepIcon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 17 17" fill="none">
                                <circle cx="8.1076" cy="8.1076" r="8.1076" fill={isActive ? '#4F80FF' : '#D9D9D9'}></circle>
                                <path d="M3.47461 7.722L6.5637 10.8111L12.7404 4.6329" stroke={isActive ? '#fff' : '#828282'} strokeWidth="1.45609" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </div>
                            <div className="__stepInfos">
                              <p>{step.name}</p>
                              {isActive && found.date && <p>{formatDateLrProcess(found.date)}</p>}
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    <div className="__lPay_details">
                      <h2>Payment Details
                        <span>INV- {lr?.billraise_id?.invoice_number || 'N/A'}</span>
                      </h2>
                    </div>

                    <div className="__pdAccordian">
                      <div className="__smAccr">
                        <h2>Total Freight</h2>
                        <h2>{formatCurrency(lr?.lr_freight?.total_freight || 0)}</h2>
                      </div>

                      <div className="accordion">
                        {/* Freight Paid */}
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <button
                              className={`accordion-button ${
                                activeAccordions[`${lrId}_freight`] ? '' : 'collapsed'
                              } ${lr?.transactions?.advance_freight?.length === 0 ? 'no-arrow' : ''}`}
                              type="button"
                              onClick={() => lr?.transactions?.advance_freight?.length > 0 && toggleAccordion(lrId, 'freight')}
                            >
                              <span className="__firstSpan">Freight Paid</span>
                              <span className="__thirdSpan">
                                {formatCurrency(calculateTotal(lr?.transactions?.advance_freight))}
                              </span>
                            </button>
                          </h2>
                          {lr?.transactions?.advance_freight?.length > 0 && (
                            <div className={`accordion-body ${activeAccordions[`${lrId}_freight`] ? 'show' : ''}`}>
                              {lr.transactions.advance_freight.map((txn, txnIndex) => (
                                <div key={txnIndex} className="__innerTb_xs">
                                  <div className="__smAccr">
                                    <h2>
                                      Advance Freight
                                      {txn.is_approval === 1 && (
                                        <span className="__underAppro_tag">Under Approval</span>
                                      )}
                                    </h2>
                                    <h2>{formatCurrency(txn.total_amount)}</h2>
                                  </div>
                                  <div className="__belowRtc">
                                    <p>{formatDate(txn.date) || '-'} | {txn.voucher_no || '-'} | {getPaymentModeName(txn) || '-'}</p>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        {/* Payable */}
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <button
                              className={`accordion-button ${
                                activeAccordions[`${lrId}_payable`] ? '' : 'collapsed'
                              } ${lr?.transactions?.pay_party_claims?.length === 0 ? 'no-arrow' : ''}`}
                              type="button"
                              onClick={() => lr?.transactions?.pay_party_claims?.length > 0 && toggleAccordion(lrId, 'payable')}
                            >
                              <span className="__firstSpan">Payable</span>
                              <span className="__thirdSpan">
                                {formatCurrency(calculateTotal(lr?.transactions?.pay_party_claims))}
                              </span>
                            </button>
                          </h2>
                          {lr?.transactions?.pay_party_claims?.length > 0 && (
                            <div className={`accordion-body ${activeAccordions[`${lrId}_payable`] ? 'show' : ''}`}>
                              {lr.transactions.pay_party_claims.map((txn, txnIndex) => (
                                <div key={txnIndex} className="__innerTb_xs">
                                  <div className="__smAccr">
                                    <h2>
                                      Claims Pay Party
                                      {txn.is_approval === 1 && (
                                        <span className="__underAppro_tag">Under Approval</span>
                                      )}
                                    </h2>
                                    <h2>{formatCurrency(txn.total_amount)}</h2>
                                  </div>
                                  <div className="__belowRtc">
                                    <p>{formatDate(txn.date) || '-'} | {txn.voucher_no || '-'} | {getPaymentModeName(txn) || '-'}</p>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        {/* Deductions */}
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <button
                              className={`accordion-button ${
                                activeAccordions[`${lrId}_deductions`] ? '' : 'collapsed'
                              } ${lr?.transactions?.charge_party_claims?.length === 0 ? 'no-arrow' : ''}`}
                              type="button"
                              onClick={() => lr?.transactions?.charge_party_claims?.length > 0 && toggleAccordion(lrId, 'deductions')}
                            >
                              <span className="__firstSpan">Deductions</span>
                              <span className="__thirdSpan">
                                {formatCurrency(calculateTotal(lr?.transactions?.charge_party_claims))}
                              </span>
                            </button>
                          </h2>
                          {lr?.transactions?.charge_party_claims?.length > 0 && (
                            <div className={`accordion-body ${activeAccordions[`${lrId}_deductions`] ? 'show' : ''}`}>
                              {lr.transactions.charge_party_claims.map((txn, txnIndex) => (
                                <div key={txnIndex} className="__innerTb_xs">
                                  <div className="__smAccr">
                                    <h2>
                                      Claims Charge Party
                                      {txn.is_approval === 1 && (
                                        <span className="__underAppro_tag">Under Approval</span>
                                      )}
                                    </h2>
                                    <h2>{formatCurrency(txn.total_amount)}</h2>
                                  </div>
                                  <div className="__belowRtc">
                                    <p>{formatDate(txn.date) || '-'} | {txn.voucher_no || '-'} | {getPaymentModeName(txn) || '-'}</p>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        <div className="__smAccr total_bar">
                          <h2>Balance</h2>
                          <h2>{formatCurrency(lr?.lr_freight?.balance || 0)}</h2>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="__collApse_nw">
                    <button
                      className={`__cleBtn ${isExpanded ? 'expanded' : ''}`}
                      type="button"
                      onClick={() => toggleLR(lrId)}
                    >
                      <span className="__viwDetail">View Details &gt;</span>
                      <span className="__viwLess">View Less &gt;</span>
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="__footmob">
          <div className="__footFirst">
            <p>This is an automatically generated report. Powered by</p>
            <p><span><a href={redirect_url}>Transport360</a></span></p>
          </div>
          <div className="__footSecond">
            <p>Manage all your Trips & Accounting Easily</p>
            <div 
              className={`__slideButton ${isDragging ? '__dragging' : ''} ${isCompleted ? '__completed' : ''}`}
              onMouseDown={handleStart}
              onMouseMove={handleMove}
              onMouseUp={handleEnd}
              onMouseLeave={handleEnd}
              onTouchStart={handleStart}
              onTouchMove={handleMove}
              onTouchEnd={handleEnd}
            >
              <div className="__slideTrack">
                <span className="__slideText">
                  {isCompleted ? 'Opening App Store...' : 'Slide to Download Transport360'}
                </span>
              </div>
              <div 
                className="__slider" 
                style={{ left: `${sliderPosition}px` }}
              >
                <i className={isCompleted ? "fa-solid fa-check" : "fa-solid fa-chevron-right"}></i>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PartyLRPaymentDetails;